import React from 'react';
import { Tabs, Stack, Paper, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IconUser, IconBuilding } from '@tabler/icons-react';
import WrappedPatientTable from './PatientTable';
import WrappedClinicPatientTable from './ClinicPatientTable';
import classes from '../../HcpPatientDashboard/Graph/tab.module.css';
import { useSessionProvider } from '../../../global/provider/sessionContext.tsx';

const TabbedPatientView: React.FC = () => {
    const { t } = useTranslation();
    const { currentUser } = useSessionProvider();

    const hasClinic = !!currentUser?.selectedHealthcareFacilityID;

    if (!hasClinic)
        return <WrappedPatientTable />;

    return (
        <Stack gap={'lg'} pt={'xl'} h="100%" w="100%">
            <Title c="black" order={3}>
                {t('page.patient.patient')}
            </Title>
            <Tabs defaultValue="primary" classNames={classes}>
                <Tabs.List>
                    <Tabs.Tab
                        value="primary"
                        leftSection={<IconUser size={16} />}
                    >
                        {t('page.patient.primaryPatients')}
                    </Tabs.Tab>
                    <Tabs.Tab
                        value="clinic"
                        leftSection={<IconBuilding size={16} />}
                    >
                        {t('page.patient.clinicPatients')}
                    </Tabs.Tab>
                </Tabs.List>

                <Tabs.Panel value="primary">
                    <Paper p="md" shadow="xs" style={{ width: '100%', borderRadius: '0 0 10px 10px' }}>
                        <WrappedPatientTable hideTitle />
                    </Paper>
                </Tabs.Panel>

                <Tabs.Panel value="clinic">
                    <Paper p="md" shadow="xs" style={{ width: '100%', borderRadius: '0 0 10px 10px' }}>
                        <WrappedClinicPatientTable />
                    </Paper>
                </Tabs.Panel>
            </Tabs>
        </Stack>
    );
};

export default TabbedPatientView;
